(function () {
  if (window.PassportPersonalizationGuardInitialized) return;
  window.PassportPersonalizationGuardInitialized = true;

  const MODAL_ID = 'PassportPersonalizationConfirm';
  const PASSPORT_PROPERTY_CLASS = 'ppc-prop';
  const PASSPORT_PROPERTY_KEYS = [
    'Pasaporte',
    'Color',
    'Nombre',
    'Apellidos',
    'Nacionalidad',
    'Fecha',
    'Modalidad',
    'Frase',
    'Imagen',
  ];
  const PASSPORT_PROPERTY_NAME_PATTERN = new RegExp(
    '^properties\\[(' + PASSPORT_PROPERTY_KEYS.join('|') + ')(\\d+)\\]$'
  );
  const MAX_BLANK_PASSPORTS = 25;
  let activeRequest = null;

  /**
   * CRO personalization funnel (GTM dataLayer). personalize_start can be
   * reached from the PDP "Personalizalo gratis" toggle and from the
   * "Personalizar ahora" popup, so it is pushed at most once per page view.
   * passport-customizer.js pushes the other steps through this same helper.
   */
  const ONCE_PER_PAGE_EVENTS = ['personalize_start'];
  const pushedOnceEvents = {};

  window.pushPassportPersonalizationEvent = function (eventName) {
    if (!eventName) return false;

    if (ONCE_PER_PAGE_EVENTS.includes(eventName)) {
      if (pushedOnceEvents[eventName]) return false;
      pushedOnceEvents[eventName] = true;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName });
    return true;
  };

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function getDialog() {
    return getModal()?.querySelector('[data-passport-confirm-dialog]');
  }

  function getCustomizer() {
    return document.getElementById('passport-customizer-modal');
  }

  function getRandomColorLabel() {
    return getCustomizer()?.getAttribute('data-random-color-label') || 'Aleatorio';
  }

  function getProductFormWrapper(form) {
    return form?.closest ? form.closest('product-form') : null;
  }

  function getCurrentProductFormId() {
    return getCustomizer()?.getAttribute('data-product-form-id') || '';
  }

  function isCurrentProductForm(form) {
    return !!(form && form.id && getCurrentProductFormId() === form.id);
  }

  function isUpsellPassportForm(form) {
    return getProductFormWrapper(form)?.dataset.passportPersonalizable === 'true';
  }

  function isCartUpsellForm(form) {
    return !!(
      form?.closest?.(
        '.cart-upsell, .cart-upsell__product, .cart-upsell__card, .cart-upsell__card-wrapper'
      ) || getProductFormWrapper(form)?.closest?.('.cart-upsell, .cart-upsell__product, .cart-upsell__card')
    );
  }

  function getPassportPersonalizationMode(form) {
    return getProductFormWrapper(form)?.dataset.passportPersonalizationMode || '';
  }

  function getUpsellProductUrl(form) {
    return getProductFormWrapper(form)?.dataset.passportProductUrl || '';
  }

  function getFormSubmitter(event, form) {
    if (event?.submitter) return event.submitter;

    if (document.activeElement?.form === form) {
      return document.activeElement;
    }

    return form?.querySelector('button[type="submit"], button[name="add"], input[type="submit"]') || null;
  }

  function clearPassportPropertyInputs(form) {
    if (!form) return;

    form.querySelectorAll('.' + PASSPORT_PROPERTY_CLASS).forEach((input) => input.remove());

    form.querySelectorAll('input[name^="properties["]').forEach((input) => {
      if (PASSPORT_PROPERTY_NAME_PATTERN.test(input.name || '')) {
        input.remove();
      }
    });
  }

  function setSkipPersonalization(form, shouldSkip) {
    const wrapper = getProductFormWrapper(form);
    if (shouldSkip) {
      form?.setAttribute?.('data-passport-skip-personalization', 'true');
      wrapper?.setAttribute?.('data-passport-skip-personalization', 'true');
      return;
    }

    form?.removeAttribute?.('data-passport-skip-personalization');
    wrapper?.removeAttribute?.('data-passport-skip-personalization');
  }

  function setBypassPromptOnce(form, shouldBypass) {
    const wrapper = getProductFormWrapper(form);
    if (shouldBypass) {
      form?.setAttribute?.('data-passport-bypass-prompt', 'true');
      wrapper?.setAttribute?.('data-passport-bypass-prompt', 'true');
      return;
    }

    form?.removeAttribute?.('data-passport-bypass-prompt');
    wrapper?.removeAttribute?.('data-passport-bypass-prompt');
  }

  function consumeBypassPrompt(form) {
    const wrapper = getProductFormWrapper(form);
    const shouldBypass =
      form?.dataset?.passportBypassPrompt === 'true' ||
      wrapper?.dataset?.passportBypassPrompt === 'true';

    if (shouldBypass) {
      setBypassPromptOnce(form, false);
      return true;
    }

    return false;
  }

  function shouldSkipPassportSyncForForm(form) {
    const wrapper = getProductFormWrapper(form);
    return (
      isCartUpsellForm(form) ||
      form?.dataset?.passportSkipPersonalization === 'true' ||
      wrapper?.dataset?.passportSkipPersonalization === 'true'
    );
  }

  function hasMeaningfulPassportValue(passport, options = {}) {
    if (!passport) return false;

    if (passport.firstName || passport.lastName || passport.nationality || passport.phrase || passport.photo) {
      return true;
    }

    if (passport.fecha || passport.modalidad) {
      return true;
    }

    const colorValue = Object.prototype.hasOwnProperty.call(options, 'colorValue')
      ? options.colorValue
      : passport.color;

    if (colorValue && colorValue !== getRandomColorLabel()) {
      return true;
    }

    return false;
  }

  function getCurrentProductPromptState() {
    if (!window.getPassportData || !window.getPassportConfig || !window.isPassportComplete) {
      return {
        shouldPrompt: true,
        firstIncompleteIndex: 0,
      };
    }

    const data = window.getPassportData() || [];
    const config = window.getPassportConfig() || {};
    const activeCount = Math.max(1, Number(config.activeCount || data.length || 1));
    const isCompact = config.isCompact === true;
    const sharedColor = config.globalColor || config.randomColorLabel || getRandomColorLabel();
    let firstIncompleteIndex = 0;
    let hasPersonalizationValue = false;
    let foundIncomplete = false;

    for (let index = 0; index < activeCount; index += 1) {
      const passport = data[index] || {};
      const colorValue = isCompact ? sharedColor : passport.color;

      if (hasMeaningfulPassportValue(passport, { colorValue })) {
        hasPersonalizationValue = true;
      }

      if (!foundIncomplete && !window.isPassportComplete(passport)) {
        firstIncompleteIndex = index;
        foundIncomplete = true;
      }
    }

    return {
      shouldPrompt: !hasPersonalizationValue,
      firstIncompleteIndex,
    };
  }

  function getPromptContext(form) {
    if (!form) return null;

    if (isCartUpsellForm(form)) {
      return null;
    }

    if (consumeBypassPrompt(form)) {
      return {
        mode: getPassportPersonalizationMode(form) === 'inline' ? 'inline' : 'navigate',
        shouldPrompt: false,
        form,
      };
    }

    if (isCurrentProductForm(form) || getPassportPersonalizationMode(form) === 'inline') {
      const promptState = getCurrentProductPromptState();

      return {
        mode: 'inline',
        shouldPrompt: promptState.shouldPrompt,
        firstIncompleteIndex: promptState.firstIncompleteIndex,
        form,
      };
    }

    if (isUpsellPassportForm(form)) {
      return {
        mode: 'navigate',
        shouldPrompt: true,
        productUrl: getUpsellProductUrl(form),
        form,
      };
    }

    return null;
  }

  window.shouldPromptPassportPersonalizationForForm = function (form) {
    const context = getPromptContext(form);
    return !!(context && context.shouldPrompt);
  };

  window.shouldSkipPassportSyncForForm = shouldSkipPassportSyncForForm;

  function restoreFocus(opener) {
    const activeDrawer = document.querySelector('cart-drawer.active');

    if (activeDrawer && typeof trapFocus === 'function') {
      const container = activeDrawer.classList.contains('is-empty')
        ? activeDrawer.querySelector('.drawer__inner-empty')
        : activeDrawer.querySelector('#CartDrawer');
      const fallback = activeDrawer.querySelector('.drawer__inner') || opener || activeDrawer;

      if (container) {
        trapFocus(container, opener || fallback);
        return;
      }
    }

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(opener || undefined);
      return;
    }

    opener?.focus?.();
  }

  function closeModal(options = {}) {
    const { restore = true } = options;
    const modal = getModal();

    if (!modal || !activeRequest) return;

    const opener = activeRequest.opener;
    const bodyWasLocked = activeRequest.bodyWasLocked;

    modal.hidden = true;
    modal.classList.remove('is-open');

    if (!bodyWasLocked) {
      document.body.classList.remove('overflow-hidden');
    }

    activeRequest = null;

    if (restore) {
      restoreFocus(opener);
    }
  }

  function openCurrentCustomizer(firstIncompleteIndex) {
    const customizer = getCustomizer();
    if (!customizer) return false;

    customizer.classList.remove('ppc--collapsed');

    const toggle = customizer.querySelector('.ppc__master-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    if (typeof window.openPassportCard === 'function') {
      window.openPassportCard(firstIncompleteIndex || 0);
    }

    const targetCard =
      customizer.querySelector(
        `.passport-card[data-passport-index="${firstIncompleteIndex || 0}"]:not(.passport-card--hidden)`
      ) || customizer.querySelector('.passport-card:not(.passport-card--hidden)') || customizer;

    targetCard.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });

    window.setTimeout(() => {
      const focusTarget =
        targetCard.querySelector('.passport-form__input, .passport-form__textarea, .passport-form__select') ||
        targetCard.querySelector('.passport-form__dropzone, .passport-card__header');

      focusTarget?.focus?.({ preventScroll: true });
    }, 350);

    return true;
  }

  function openModal(context) {
    const modal = getModal();
    const dialog = getDialog();

    if (!modal || !dialog) return false;

    activeRequest = {
      ...context,
      opener: document.activeElement,
      bodyWasLocked: document.body.classList.contains('overflow-hidden'),
    };

    modal.hidden = false;
    modal.classList.add('is-open');

    if (!activeRequest.bodyWasLocked) {
      document.body.classList.add('overflow-hidden');
    }

    if (typeof trapFocus === 'function') {
      trapFocus(modal, dialog);
    } else {
      dialog.focus();
    }

    return true;
  }

  function setHiddenProperty(form, name, value, className) {
    let input = form.querySelector(`input[name="${name}"]`);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    if (className && !input.classList.contains(className)) {
      input.classList.add(className);
    }

    input.value = value;
  }

  function removeHiddenProperty(form, name) {
    const input = form.querySelector(
      `input[name="${name}"]`
    );

    if (input) {
      input.remove();
    }
  }


  function getFormQuantity(form) {
    if (!form) return 0;

    let input = form.querySelector('input[name="quantity"]');

    if (!input && form.id) {
      input = document.querySelector(`input[name="quantity"][form="${form.id}"]`);
    }

    const quantity = parseInt(input?.value, 10);

    return Number.isNaN(quantity) || quantity < 1 ? 0 : quantity;
  }

  /**
   * How many passports this line item will physically contain.
   * Packs / bundles: the customizer already tracks it as activeCount.
   * Anything else: fall back to the quantity being added to cart.
   */
  function getPassportCountForForm(form) {
    const config = window.getPassportConfig ? window.getPassportConfig() : null;
    const usesCurrentCustomizer =
      isCurrentProductForm(form) || getPassportPersonalizationMode(form) === 'inline';

    let count = 0;

    if (usesCurrentCustomizer && config) {
      count = parseInt(config.activeCount, 10) || 0;
    }

    count = Math.max(count, getFormQuantity(form));

    if (count < 1) count = 1;

    return Math.min(count, MAX_BLANK_PASSPORTS);
  }

  /**
   * "Add to cart without personalizing" must still describe EVERY passport in
   * the line item, otherwise fulfilment only receives one passport for a pack
   * or a multi-quantity order. Unpersonalized passports are sent blank.
   */
  function addWithoutCustomizationProperties(form) {
    const config = window.getPassportConfig
      ? window.getPassportConfig()
      : null;

    const editionTags = config?.editionTags || [];
    const isCompact = config?.isCompact || false;
    const randomColorLabel = config?.randomColorLabel || getRandomColorLabel();
    const globalColor = config?.globalColor || randomColorLabel;
    const passportCount = getPassportCountForForm(form);

    clearPassportPropertyInputs(form);

    for (let index = 0; index < passportCount; index += 1) {
      const num = index + 1;

      setHiddenProperty(
        form,
        `properties[Pasaporte${num}]`,
        editionTags[index] || editionTags[0] || '',
        PASSPORT_PROPERTY_CLASS
      );

      setHiddenProperty(
        form,
        `properties[Color${num}]`,
        isCompact ? globalColor : randomColorLabel,
        PASSPORT_PROPERTY_CLASS
      );

      setHiddenProperty(form, `properties[Nombre${num}]`, '', PASSPORT_PROPERTY_CLASS);
      setHiddenProperty(form, `properties[Apellidos${num}]`, '', PASSPORT_PROPERTY_CLASS);
      setHiddenProperty(form, `properties[Nacionalidad${num}]`, '', PASSPORT_PROPERTY_CLASS);
      setHiddenProperty(form, `properties[Frase${num}]`, '', PASSPORT_PROPERTY_CLASS);
    }

    setHiddenProperty(form, 'properties[_Customized]', 'false');
  }

  function submitWithoutPersonalization() {
    if (!activeRequest?.form) {
      closeModal();
      return;
    }

    const { form, submitter } = activeRequest;

    setBypassPromptOnce(form, true);
    form.dataset.passportCustomized = 'false';
    setSkipPersonalization(form, false);
    addWithoutCustomizationProperties(form);
    closeModal({ restore: false });

    window.requestAnimationFrame(() => {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter || undefined);
      } else if (submitter?.click) {
        submitter.click();
      } else {
        form.submit();
      }
    });
  }

  function personalizeNow() {
    if (!activeRequest) {
      closeModal();
      return;
    }

    const { mode, productUrl, firstIncompleteIndex } = activeRequest;
    closeModal({ restore: false });

    if (mode === 'inline') {
      if (openCurrentCustomizer(firstIncompleteIndex)) {
        window.pushPassportPersonalizationEvent('personalize_start');
      }
      return;
    }

    if (productUrl) {
      window.location.href = productUrl;
    }
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.closest('product-form')) return;

      removeHiddenProperty(
        form,
        'properties[_Customized]'
      );

      const customizedState =
        form.dataset.passportCustomized ||
        (sessionStorage.getItem('passport_customize_redirect')
          ? 'true'
          : null);

      if (customizedState) {
        setHiddenProperty(
          form,
          'properties[_Customized]',
          customizedState
        );

        sessionStorage.removeItem(
          'passport_customize_redirect'
        );
      }
      delete form.dataset.passportCustomized;


      if (shouldSkipPassportSyncForForm(form)) {
        setSkipPersonalization(form, false);
        clearPassportPropertyInputs(form);
        return;
      }

      const context = getPromptContext(form);
      if (!context || !context.shouldPrompt) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openModal({
        ...context,
        submitter: getFormSubmitter(event, form),
      });
    },
    true
  );

  document.addEventListener('click', (event) => {
    const closeTrigger = event.target.closest('[data-passport-confirm-close]');
    if (closeTrigger) {
      closeModal();
      return;
    }

    const continueTrigger = event.target.closest('[data-passport-confirm-continue]');
    if (continueTrigger) {
      submitWithoutPersonalization();
      return;
    }

    const personalizeTrigger = event.target.closest('[data-passport-confirm-personalize]');
    if (personalizeTrigger) {
      personalizeNow();
    }
  });

  document.addEventListener(
    'keyup',
    (event) => {
      if (event.key === 'Escape' && activeRequest) {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
      }
    },
    true
  );
})();
